let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jOrC1")).then(() => parcelRequire('eX7U3'));